const component = "section-appliance-text";

export const sectionApplianceText = {
  component,
};
